import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import React from "react";
import { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

const P = styled(Typography)`
  color: #ffffff;
  font-family: poppins-semibold;
`
const P1 = styled(Typography)`
  color: #ffffff;
  font-family: poppins-regular;
`
const BoxStyle = styled(Box)`
  background: linear-gradient( to top, #000000, #1C1C1C );
  border-radius: 20px;
  max-width: 300px;
  padding: 25px;
  margin: 20px auto;
`

const Cards = (props) => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      offset: 200,
    });
  }, []);  
  useEffect(() => {
    AOS.refresh();
  });

  const {name, desc} = props;
  return(
    <BoxStyle data-aos="zoom-in-up">
      <P variant="h6">{name}</P>
      <P1 variant="subtitle-1">{desc}</P1>
    </BoxStyle>
  )
}
export default Cards;